import { createFeatureSelector, createSelector } from "@ngrx/store";
import { SharedState } from "./shared-state-interface";

export const selectSharedState = createFeatureSelector<SharedState>("sharedContext");

export const selectExchangeState = createSelector(selectSharedState, (state: SharedState) => state.exchangesState);

export const getAllExchanges = createSelector(selectExchangeState, (state) => state?.exchanges);

export const getExchangeLoaded = createSelector(selectExchangeState, (state) => state?.loaded);

export const selectReferenceState = createSelector(selectSharedState, (state: SharedState) => state.referenceState);

export const selectExchangeTypeReference = createSelector(selectReferenceState, (state) => state?.exchangeTypes);

export const getIsExchangeTypeLoaded = createSelector(selectReferenceState, (state) => state?.exchangeTypesLoaded);

export const selectOrderCurrencyReference = createSelector(selectReferenceState, (state) => state?.orderCurrencies);

export const getIsOrderCurrencyLoaded = createSelector(selectReferenceState, (state) => state?.orderCurrenciesLoaded);

export const getOrderCreateCurrencies = createSelector(selectReferenceState, (state) => state?.orderCreateCurrencies);

export const getIsOrderTransactionTypesLoaded = createSelector(selectReferenceState, (state) => state?.OrderTransactionTypesLoaded);

export const getOrderTransactionTypes = createSelector(selectReferenceState, (state) => state?.OrderTransactionTypes);

export const selectUserState = createSelector(selectSharedState, (state: SharedState) => state.userState);

export const getAllUsers = createSelector(selectUserState, (state) => state?.users);

export const getAreUsersLoaded = createSelector(selectUserState, (state) => state?.loaded);

export const selectWorkTrayReference = createSelector(selectReferenceState, (state) => state?.workTrays);

export const getRoleTypes = createSelector(selectReferenceState, (state) => state?.roleTypes);

export const getRoleTypesLoaded = createSelector(selectReferenceState, (state) => state?.roleTypesLoaded);

export const getTransactionypes = createSelector(selectReferenceState, (state) => state?.transactionTypes);

export const getTransactionypesLoaded = createSelector(selectReferenceState, (state) => state?.transactionTypesLoaded);

export const getAccountCurrencies = createSelector(selectReferenceState, (state) => state?.accountCurrencies);

export const getAccountCurrenciesLoaded = createSelector(selectReferenceState, (state) => state?.accountCurrenciesLoaded);

export const getCompanyAccountCurrencies = createSelector(selectReferenceState, (state) => state?.companyAccountCurrencies);

export const getCompanyAccountCurrenciesLoaded = createSelector(selectReferenceState, (state) => state?.companyAccountCurrenciesLoaded);

export const getExpensesCurrencies = createSelector(selectReferenceState, (state) => state?.expensesCurrencies);

export const getExpensesCurrenciesLoaded = createSelector(selectReferenceState, (state) => state?.expensesCurrenciesLoaded);

export const getCustomerRoleTypes = createSelector(selectReferenceState, (state) => state?.customerRoles);

export const getCustomerRoleTypesLoaded = createSelector(selectReferenceState, (state) => state?.customerRolesLoaded);

export const getOffices = createSelector(selectReferenceState, (state) => state?.offices);

export const getOfficesLoaded = createSelector(selectReferenceState, (state) => state?.officesLoaded);

export const getProducerList = createSelector(selectReferenceState, (state) => state?.ProducerList);

export const getProducerListLoaded = createSelector(selectReferenceState, (state) => state?.ProducerListLoaded);

export const getProductTypes = createSelector(selectReferenceState, (state) => state?.productTypes);

export const getProductAPITypes = createSelector(selectReferenceState, (state) => state?.productAPITypes);

export const getProductTypesLoaded = createSelector(selectReferenceState, (state) => state?.productTypesLoaded);

/** REFERENCES */
export const getCompanyVirtualAccounts = createSelector(selectReferenceState, (state) => state?.companyVirtualAccounts);

export const getCompanyVirtualAccountsLoaded = createSelector(selectReferenceState, (state) => state?.companyVirtualAccountsLoaded);


// Help Tour
export const getHelpTour = createSelector(selectSharedState, (state) => state?.helpTourCompnent);

export const getHelpFlag = createSelector(selectSharedState, (state) => state?.workInProgress);

// Notification
export const selectNotification = createSelector(selectSharedState, (state) => state?.notifications);

export const getNotificationCount = createSelector(selectNotification, (state) => state?.notificationCount);

export const getNotifications = createSelector(selectNotification, (state) => state?.notifications?.entity);

export const getNotificationsLoaded = createSelector(selectNotification, (state) => state?.notifications?.loaded);

/* CUSTOMERS SELECTORS */

export const selectCustomers = createSelector(selectSharedState, (state) => state?.customers);

export const getCustomersForOrder = createSelector(selectCustomers, (state) => state?.customers);

export const getCustomersForProduct = createSelector(selectCustomers, (state) => state?.customers);

/* Supplier SELECTORS */

export const selectSuppliers = createSelector(selectSharedState, (state) => state?.suppliers);

export const getSuppliers = createSelector(selectSuppliers, (state) => state?.suppliers);

/* COMPANY SETTINGS SELECTORS */

export const selectCompanySettings = createSelector(selectSharedState, (state) => state?.comapnySettings);

export const getCompanySettings = createSelector(selectCompanySettings, (state) => state?.comapnySettings);
export const getCompanySettingsLoaded = createSelector(selectCompanySettings, (state) => state?.comapnySettingsLoaded);
export const getCompanySettingsOrder = createSelector(getCompanySettings, (state) => state?.order);
export const getCompanySettingsProduct = createSelector(getCompanySettings, (state) => state?.product);
export const getCompanySettingsAccount = createSelector(getCompanySettings, (state) => state?.account);
export const getCompanySettingsAssignment = createSelector(getCompanySettings, (state) => state?.assignment);


/* Expenses */

export const selectReasons = createSelector(selectSharedState, (state) => state?.reasons);

export const getReasonsForExpenses = createSelector(selectReasons, (state) => state?.reasons);
